import { render } from "./BlankView.vue?vue&type=template&id=380fab30"
const script = {}

import exportComponent from "/var/www/keyvue-customer-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__